import {Typography, Button} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useParams, useNavigate, useSearchParams} from "react-router-dom"
import {format} from "date-fns"

import {useAnalytics} from "@indebted/analytics"
import {Page} from "@indebted/components/Page"
import {CalendarCheckIcon} from "@indebted/assets"

function FortnightlyPayDay({i18n, frequency, todayStartDateEnabled}) {
	const {track} = useAnalytics()
	const navigate = useNavigate()
	const [params] = useSearchParams()
	const {secureCode} = useParams()
	track("PPDayPageViewed", {
		SecureCode: secureCode,
	})

	const options = frequency.Options.reduce((list, option) => {
		if (list.indexOf(option.Weekday) == -1) {
			list.push(option.Weekday)
		}

		return list
	}, [])

	function WeekdayButton({weekday}) {
		return (
			<Grid>
				<Button
					fullWidth
					variant="outlined"
					onClick={() => {
						track("PPDayButtonClicked", {
							SecureCode: secureCode,
						})
						navigate(`../FortnightlyNextPayDate?${params}&frequency=Fortnightly&weekday=${weekday}`)
					}}
				>
					{weekday}
				</Button>
			</Grid>
		)
	}

	function PayDayOptions() {
		return (
			<>
				<Grid>
					<Typography variant="h6">{i18n.DateSelection.DateSelectionHeader}</Typography>
				</Grid>
				<Grid>
					<Typography>{i18n.DateSelection.PayDateTitle}</Typography>
				</Grid>

				<Grid container direction="column" alignItems="stretch" spacing={5}>
					{options.map((weekday) => (
						<WeekdayButton key={weekday} weekday={weekday} />
					))}
				</Grid>

				<Grid container direction="column" alignItems="stretch" spacing={5}>
					<Grid>
						<Typography variant="h6">{i18n.DateSelection.CustomStartDateHeader}</Typography>
					</Grid>
					<Grid>
						<Typography>{i18n.DateSelection.CustomStartDateDescription}</Typography>
					</Grid>
				</Grid>
				<Grid container direction="column" alignItems="stretch" spacing={5}>
					<Grid>
						<Button
							fullWidth
							variant="outlined"
							onClick={() => {
								track("PPDayButtonClicked", {
									SecureCode: secureCode,
								})
								navigate(`../CustomStartDate?${params}&frequency=${frequency.ID}`)
							}}
						>
							{frequency.CustomStartDate.Display}
						</Button>
					</Grid>
				</Grid>
			</>
		)
	}

	function PayTodayButton({buttonLabel}) {
		return (
			<Grid>
				<Button
					fullWidth
					variant="outlined"
					onClick={() => {
						track("PPPayTodayButtonClicked", {
							SecureCode: secureCode,
						})
						const date = format(new Date(), "yyyy-MM-dd")
						navigate(`../Amount?${params}&frequency=${frequency.ID}&payday=&startdate=${date}`)
					}}
				>
					{buttonLabel}
				</Button>
			</Grid>
		)
	}

	function TodayStartDate() {
		return (
			<>
				<Grid>
					<Typography variant="h6">{i18n.PayToday.Header}</Typography>
				</Grid>
				<Grid>
					<Typography>{i18n.PayToday.TitleFortnightly}</Typography>
				</Grid>

				<PayTodayButton buttonLabel={i18n.PayToday.ButtonLabel} />

				<Grid>
					<Button
						fullWidth
						variant="outlined"
						startIcon={<CalendarCheckIcon />}
						onClick={() => {
							track("PPDayButtonClicked", {
								SecureCode: secureCode,
							})
							navigate(`../CustomStartDate?${params}&frequency=${frequency.ID}`)
						}}
					>
						{i18n.PayToday.CustomStartDateButtonLabel}
					</Button>
				</Grid>
			</>
		)
	}

	return (
		<Page padded>
			<Grid container direction="column" alignItems="stretch" justifyContent="center" spacing={5} padding={0}>
				{todayStartDateEnabled ? <TodayStartDate /> : <PayDayOptions />}
			</Grid>
		</Page>
	)
}

export {FortnightlyPayDay}
